/**
 * ISO 3166-1 alpha-2 → country name lookup, with a small subset of the
 * countries most relevant to Timely traffic at the top.
 *
 * The TopoJSON world atlas (Natural Earth 110m) is loaded lazily by the
 * WorldMap component to keep the main bundle small.
 */

const NAMES: Record<string, string> = {
  AU: "Australia", NZ: "New Zealand", US: "United States", GB: "United Kingdom",
  CA: "Canada", IE: "Ireland", DE: "Germany", FR: "France", NL: "Netherlands",
  ES: "Spain", IT: "Italy", SE: "Sweden", NO: "Norway", DK: "Denmark",
  FI: "Finland", PL: "Poland", CH: "Switzerland", AT: "Austria", BE: "Belgium",
  ZA: "South Africa", BR: "Brazil", MX: "Mexico", AR: "Argentina", CL: "Chile",
  IN: "India", SG: "Singapore", JP: "Japan", KR: "South Korea", HK: "Hong Kong",
  TW: "Taiwan", PH: "Philippines", ID: "Indonesia", MY: "Malaysia", TH: "Thailand",
  VN: "Vietnam", AE: "United Arab Emirates", SA: "Saudi Arabia", IL: "Israel",
  TR: "Türkiye", RU: "Russia", UA: "Ukraine", CN: "China", PK: "Pakistan",
  BD: "Bangladesh", NG: "Nigeria", KE: "Kenya", EG: "Egypt", MA: "Morocco",
};

export function countryName(iso2: string): string {
  if (!iso2) return "Unknown";
  const u = iso2.toUpperCase();
  return NAMES[u] ?? u;
}

/**
 * URL of the Natural Earth 110m countries TopoJSON, served by jsDelivr-
 * mirrored world-atlas. We pin the version. The map component fetches
 * this lazily. (No analytics or cookies — static asset.)
 */
export const WORLD_ATLAS_URL =
  "https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json";

/**
 * Numeric ISO codes used by Natural Earth → ISO 3166-1 alpha-2 mapping.
 * We only carry the ~60 most-trafficked countries; everything else
 * renders but won't tooltip with a friendly name. Extend as needed.
 */
export const NUM_TO_ISO2: Record<string, string> = {
  "036": "AU", "554": "NZ", "840": "US", "826": "GB", "124": "CA", "372": "IE",
  "276": "DE", "250": "FR", "528": "NL", "724": "ES", "380": "IT", "752": "SE",
  "578": "NO", "208": "DK", "246": "FI", "616": "PL", "756": "CH", "040": "AT",
  "056": "BE", "710": "ZA", "076": "BR", "484": "MX", "032": "AR", "152": "CL",
  "356": "IN", "702": "SG", "392": "JP", "410": "KR", "344": "HK", "158": "TW",
  "608": "PH", "360": "ID", "458": "MY", "764": "TH", "704": "VN", "784": "AE",
  "682": "SA", "376": "IL", "792": "TR", "643": "RU", "804": "UA", "156": "CN",
  "586": "PK", "050": "BD", "566": "NG", "404": "KE", "818": "EG", "504": "MA",
};
